'use client';

import Link from '@eliadmin/core/src/components/link';

import type { GenericHeaderProps } from '@eliadmin/core/src/components/header/header-client';

import { HeaderCartButton } from '@eliadmin/core/src/components/header/header-cart-button';
import { HeaderProfileButton } from '@eliadmin/core/src/components/header/header-profile-button';
import { MobileSearchProvider } from '@eliadmin/core/src/components/header/mobile-search';
import { SearchButton } from '@eliadmin/core/src/components/header/search-button';
import MobileSidebar from '@eliadmin/core/src/components/header/mobile-sidebar';
import { HeaderSearchBar } from '@eliadmin/core/src/components/header/search-bar';
import { HeaderFavoritesButton } from '@eliadmin/core/src/components/header/header-favorites-button';
import { Logo } from '@eliadmin/core/src/components/ui/logo';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { HeaderCatalogue } from '@eliadmin/core/src/components/header/header-catalogue';
import { MdOutlineSell } from 'react-icons/md';
import { RiAsterisk } from 'react-icons/ri';

export function HeaderMain(props: GenericHeaderProps) {
  const me = useCustomerStore(s => s.me);
  const isInitialized = useCustomerStore(s => s.isInitialized);

  const { t } = useTranslations();

  const isLoggedIn = me?.customer && !!isInitialized;

  return (
    <MobileSearchProvider>
      <div className={cn('custom-section', 'bg-white py-[10px] sm:py-3')}>
        <div className={cn('custom-container', 'flex items-center justify-between')}>
          <div className="flex w-full flex-1 items-start justify-start sm:hidden">
            <MobileSidebar side="left" categories={props.categories} menu={props.menu.fields} />
          </div>
          <div className="flex items-center justify-start sm:w-full sm:flex-1">
            <Logo className={{ image: 'h-10 sm:h-[60px]' }} generalLayout={props.generalLayout} />
          </div>
          <div className="hidden min-w-[400px] max-w-[400px] lg:block">
            <HeaderSearchBar />
          </div>
          <div className="flex w-full flex-1 items-center justify-end gap-6">
            <div className="flex items-center justify-center lg:hidden">
              <SearchButton />
            </div>
            <div className="hidden items-center justify-end gap-6 sm:flex">
              <HeaderProfileButton />
              {isLoggedIn && <HeaderFavoritesButton />}
              <HeaderCartButton />
            </div>
          </div>
        </div>
      </div>
      <div className={cn('custom-section', 'hidden bg-white py-[12.5px] sm:flex')}>
        <div className={cn('custom-container', 'relative flex items-center justify-between')}>
          <div className="flex items-center justify-start gap-6">
            <HeaderCatalogue categories={props.categories} locale={props.locale} />
            <Link
              href={'/akcne-produkty'}
              prefetchOnHover
              className="flex items-center justify-start gap-1 text-sm font-bold lg:text-base"
            >
              <MdOutlineSell size={20} />
              {t('text3756')}
            </Link>
            <Link
              href={'/saprem-expert'}
              prefetchOnHover
              className="flex items-center justify-start gap-1 text-sm font-bold lg:text-base"
            >
              <RiAsterisk size={20} />
              Saprem Expert
            </Link>
          </div>
        </div>
      </div>
    </MobileSearchProvider>
  );
}
